import { ProductDetailComponent } from './../../components/product-detail/product-detail.component';
import { inject, Injectable } from '@angular/core';
import { AssortmentTreeListComponent } from '../../components/assortment-tree-list/assortment-tree-list.component';
import { ConceptTreeListComponent } from '../../components/concept-tree-list/concept-tree-list.component';
import { ProductTreeListComponent } from '../../components/product-tree-list/product-tree-list.component';
import { ConceptDetailComponent } from '../../components/concept-detail/concept-detail.component';
import { BaseViewConfigService } from '../base-view-config/base-view-config.service';
import { filter, first, Observable, switchMap } from 'rxjs';
import { Assortment, AssortmentService } from '../assortment.service';
import { GungFlowService } from '../gung-flow/gung-flow.service';

@Injectable({
  providedIn: 'root'
})
export class AssortmentTreeNavigationConfigService {
  protected baseViewConfigService = inject(BaseViewConfigService);
  protected assortmentService = inject(AssortmentService);
  protected gungFlowService = inject(GungFlowService);

  ignoreFilterOnConcept = false;
  protected getAssortmentWithFlowFilter: boolean = this.baseViewConfigService.getAssortmentWithFlowFilter;
  protected getAssortmentNoProducts: boolean = this.baseViewConfigService.getAssortmentNoProducts;

  getAssortmentLayout(): any {
    return AssortmentTreeListComponent;
  }

  getConceptLayout() {
    return ConceptTreeListComponent;
  }

  getConceptDetailLayout() {
    return ConceptDetailComponent;
  }

  getProductsLayout() {
    return ProductTreeListComponent;
  }

  getProductDetailLayout() {
    return this.baseViewConfigService.getProductDetailComponent();
  }

  getAssortment(assortmentId: string): Observable<Assortment> {
    if (this.getAssortmentWithFlowFilter) {
      return this.gungFlowService.getSelectedFlow().pipe(
        filter(flow => !!flow),
        first(),
        switchMap(flow => {
          return this.assortmentService.getAssortmentRecursiveWithFlowFilter(assortmentId, flow.id).pipe(first());
        })
      );
    }

    return this.assortmentService.getAssortmentRecursive(assortmentId).pipe(first());
  }
}
